import { gql } from '@apollo/client';

export const questFragment = gql`
    fragment QuestFields on Quest {
        id
        description
        dueDate
        name
        status
        tracking
        timing
        timedInterval
        timerValueInMs
        difficulty
        completedOn
        repeat {
            query
            repeatingType
            interval
            weekDays
            monthDays
            startHour
            startMinute
        }
        categoryId
        metric {
            completed
            xpPoints
            completedTimes
            timeSpentSec
        }
        goalId
        templateId
        ritualType
        external
        externalDeepLink
        subTasks {
            name
            done
            taskType
            promptText
            journalEntryId
            ratingEntryId
        }
    }
`;
